
import { AddVendors} from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link,useNavigate } from "react-router-dom";
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import { useCountry } from "../contexts/countrycodecontext.js";

const VendorProfile = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const navigate = useNavigate();
  const { selectedCountry} = useCountry();

  const onSubmit = (data, e) => {
    e.preventDefault();
    AddData(data);

  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }
  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const token = localStorage.getItem("jwtToken")
  const roleID = localStorage.getItem("roleID")
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  console.log("guid",Guid)
console.log("466,",selectedCountry)
  const AddData = async(data) => {
       const params={
        "userGuid":Guid,
        "vendorName": data.vendorName,
        "vendorEmail": data.vendorEmail,
        "phoneNumber": data.phoneNumber,
        "vendorAddress":data.vendorAddress,
        "vendorCompanyName": data.vendorCompanyName,
        "vendorCompanyAddress": data.vendorCompanyAddress,
        "countryID":selectedCountry
    }

    apiUrl = AddVendors.APIURL;
    Axios.post(apiUrl, params,{ headers: { Authorization: `Bearer ${token}` } })
      .then((result) => {
             if (result.data.message === 'Vendor  added successfully') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Added Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
          navigate("/Employer/ListofClients")

          // toast.success('Data Saving', {autoClose:5000})

        }
        else {
          // toast.error('Issue with data format', {autoClose:5000})
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Add correct Details',
            showConfirmButton: false,
            timer: 5000
          })
        }

      }).catch(
        function (error) {
          console.log("Error" + error)
        })

  }
  

  useEffect(() => {

  }, []);

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListofClients">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Add Client</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
          <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
         
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Client Name</Tooltip>)}>
                <input type="text" name="vendorName"  {...register("vendorName", { required: "Client Name required" })} placeholder="Client Name" className={`form-control basic-form  ${errors.vendorName ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.vendorName?.message}</div>
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Client Email</Tooltip>)}>
                <input type="vendorEmail"  name="vendorEmail" {...register("vendorEmail", { required: "Client Email required" })}  placeholder="Client Email" className={`form-control basic-form ${errors.vendorEmail ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.vendorEmail?.message}</div>
              <div className="mt-4">
                              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Webiste</Tooltip>)}>
                <input type="text" title="" name="vendorAddress" {...register("vendorAddress")} placeholder="Company Website" className={`form-control basic-form`} />
              </OverlayTrigger>
        </div>
         </div>
         <div className="mt-4"> 
      </div>
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="Number"
                  min="0"
                  title=''
                  name="phoneNumber"
                  disabled={isDisabled}
                  {...register("phoneNumber" , { required: "Client Mobile Number required" })}
                  className={`form-control basic-form ${errors.phoneNumber ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.phoneNumber?.message}</div>

             
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Company Name</Tooltip>)}>
                <input type="text" title="" name="vendorCompanyName" {...register("vendorCompanyName", { required: "Client Company Name required" })} placeholder="Client Company Name " className={`form-control basic-form ${errors.vendorCompanyName ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.vendorCompanyName?.message}</div>
              <div className="mt-4">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Company Address</Tooltip>)}>
                <input type="text" title="" name="vendorCompanyAddress" {...register("vendorCompanyAddress")} placeholder="Client Company Address " className={`form-control basic-form`} />
              </OverlayTrigger>
        </div>
         </div>
           </div>

          </div>
         
    
          <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/ListofClients"> 
             <button  style={{float:"right"}}    disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                  Cancel
                </button>
                </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Save
              </button> &nbsp;&nbsp;&nbsp;
            </div>
        </div>
        </form>
        </div>
        </div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default VendorProfile;